import axios from 'axios';
import { normalizeGetTableQuery } from '@/utils/globalHelpers';

export class ReferenceService {
  async saveOrder(data) {
    return await axios.post('/api/v1/portal/modify', data);
  }

  // async updateOrder(orderId, data) {
  //   return await axios.patch(`/api/v1/portal/modify/${orderId}`, data);
  // }
  async getPickupList(isPickup, params) {
    return await axios.get('/api/v1/portal/pickup/order/list?isPickup=' + isPickup, {
      params: normalizeGetTableQuery(params)
    });
  }
  async getUserPickupList(isPickup, params) {
    return await axios.get('/api/v1/portal/pickup/listOrderPickup', {
      params: normalizeGetTableQuery(params)
    });
  }
  async getReferenceFinancialItems(params, itemType, orderId) {
    return await axios.get(`/api/v1/portal/orderFinancialTransaction?order_id=${orderId}&type=${itemType}`, {
      params: normalizeGetTableQuery(params)
    });
  }
  async getReferenceFinancialSummary(orderId) {
    return await axios.get(`/api/v1/portal/order/${orderId}/financial-summary`);
  }
  async getReferences(params, customerId) {
    const tableParams = normalizeGetTableQuery(params);
    if (customerId) {
      tableParams.customer_id = customerId;
    }
    return await axios.get('/api/v1/portal/order', { params: tableParams });
  }

  async getReferencesByType(params, type, customerId) {
    const tableParams = normalizeGetTableQuery(params);
    if (customerId) {
      tableParams.customer_id = customerId;
    }
    if (type) {
      return await axios.get(`/api/v1/portal/orders/${type}`, { params: tableParams });
    }
    return await axios.get('/api/v1/portal/orders', { params: tableParams });
  }

  async getNonConsoleReferences(params, type, manifestType = 'airline') {
    const tableParams = normalizeGetTableQuery(params);
    return await axios.get('/api/v1/portal/consoleManifest/order', {
      params: { ...tableParams, type, manifest_type: manifestType }
    });
  }
  async getReferencesTracking(orderId, params) {
    return await axios.get(`/api/v1/portal/order/${orderId}/tracking/list`, { params: normalizeGetTableQuery(params) });
  }
  async getShipmentLifecycle(orderId) {
    return await axios.get(`/api/v1/portal/order/${orderId}/lifecycle`);
  }
  async getShipmentAudit(orderId) {
    return await axios.get(`/api/v1/portal/order/${orderId}/audit-log`);
  }
  async transitionShipmentStatus(orderId, data) {
    return await axios.post(`/api/v1/portal/order/${orderId}/lifecycle/transition`, data);
  }
  async validateOtp(orderId, otpCode) {
    return await axios.post(`/api/v1/portal/validateOtp/${orderId}`, { otpCode: otpCode });
  }
  async sendOtp(orderId) {
    return await axios.post(`/api/v1/portal/sendOtp/${orderId}`);
  }

  async createReference(data) {
    return await axios.post('/api/v1/portal/order', data);
  }
  async previewReferenceRate(data) {
    return await axios.post('/api/v1/portal/order/rate-preview', data);
  }
  async getShipmentDraft(shipmentType) {
    return await axios.get(`/api/v1/portal/shipment-drafts/${shipmentType}`);
  }
  async saveShipmentDraft(shipmentType, data) {
    return await axios.put(`/api/v1/portal/shipment-drafts/${shipmentType}`, data, { timeout: 5000 });
  }
  async deleteShipmentDraft(shipmentType) {
    return await axios.delete(`/api/v1/portal/shipment-drafts/${shipmentType}`);
  }
  async createCustomer(data) {
    return await axios.post('/api/v1/portal/customer', data);
  }
  async editReference(id, data) {
    return await axios.patch(`/api/v1/portal/order/${id}`, data);
  }
  async changeStatus(data) {
    return await axios.post(`/api/v1/portal/order/changeStatus/${data.id}`, data);
  }
  async setReceiverData(data, orderId) {
    return await axios.post(`/api/v1/portal/order/setReceiverInfo/${orderId}`, data);
  }
  async setReceiverById(orderId, customerId) {
    return await axios.post(`/api/v1/portal/order/setReceiverInfo/${orderId}`, { customer_id: customerId });
  }
  async updateOrder(data, orderId) {
    return await axios.patch(`/api/v1/portal/order/update/${orderId}`, data);
  }
  async createOrderTracking(data) {
    return await axios.post(`/api/v1/portal/orderTracking`, data);
  }
  async createInvoice(data) {
    return await axios.post(`/api/v1/portal/invoice`, data);
  }
  async updateOrderTracking(data, statusId) {
    return await axios.put(`api/v1/portal/orderTracking/${statusId}`, data);
  }
  async createBulkOrderTracking(data) {
    console.log(data);
    return await axios.post(`api/v1/portal/orderTracking/setStatusOrders`, data);
  }
  async createOrderFinancialItem(data) {
    return await axios.post(`/api/v1/portal/orderFinancialTransaction`, data);
  }
  async updateOrderFinancialItem(data, itemId) {
    return await axios.put(`api/v1/portal/orderFinancialTransaction/${itemId}`, data);
  }
  async saveFlightInfo(data, orderId) {
    return await axios.post(`api/v1/portal/order/infoFlight/${orderId}`, data);
  }
  async createManifest(data) {
    return await axios.post(`api/v1/portal/consoleManifest`, data);
  }
  async updateManifest(data, id) {
    return await axios.post(`api/v1/portal/consoleManifest/setInformation/${id}`, data);
  }

  async getTrackingCustomer(code) {
    const data = {
      code: code
    };
    return await axios.post(`api/v1/orderTracking/getTrackingOrders`, data);
  }
}
